export enum CountryEnum {
  UnitedStates = 'US',
  NonUS = 'Non-US',
}
